"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardActions = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const Dialog_1 = require("../../../Dialog");
exports.WizardActions = react_1.default.memo(({ loading, prev, next, skip, done, cancel }) => {
    const { t } = (0, core_1.useFeatureContext)();
    return (react_1.default.createElement(Dialog_1.DialogActions, { loading: loading, primary: [
            !prev.hidden && {
                id: 'previous',
                text: prev.title || t('wizard|actions|previous') || 'Previous',
                view: Dialog_1.ACTION_VIEW.alternate,
                disabled: prev.disabled,
                onClick: prev.didSelect
            },
            !next.hidden && {
                id: 'next',
                text: next.title || t('wizard|actions|next') || 'Next',
                view: Dialog_1.ACTION_VIEW.primary,
                disabled: next.disabled,
                onClick: next.didSelect
            },
            !skip.hidden && {
                id: 'skip',
                text: skip.title || t('wizard|actions|skip') || 'Skip',
                view: Dialog_1.ACTION_VIEW.primary,
                disabled: skip.disabled,
                onClick: skip.didSelect
            },
            !done.hidden && {
                id: 'done',
                text: done.title || t('wizard|actions|done') || 'Finish',
                view: Dialog_1.ACTION_VIEW.primary,
                disabled: done.disabled,
                onClick: done.didSelect
            },
            !cancel.hidden && {
                id: 'cancel',
                text: cancel.title || t('wizard|actions|cancel') || 'Cancel',
                view: 'secondary',
                disabled: cancel.disabled,
                onClick: cancel.didSelect
            }
        ].filter(Boolean) }));
});
//# sourceMappingURL=WizardActions.js.map